/**
 * Returns OneTrust's API.
 */
const getApi = () => {
    const oneTrust = window.OneTrust;
    if (oneTrust &&
        typeof oneTrust === 'object' &&
        'OnConsentChanged' in oneTrust &&
        'GetDomainData' in oneTrust) {
        return oneTrust;
    }
    return undefined;
};
/**
 * Returns whether the user can currently be tracked.
 */
const userCanBeTracked = () => {
    // Always loads, a la `consentModel: 'opt-out'` in the Segment wrapper.
    const api = getApi();
    return !!api;
};
/**
 * Returns the user's current consent configuration.
 */
const getCurrentConsent = () => {
    const api = getApi();
    const activeGroups = window.OnetrustActiveGroups;
    if (!api || !activeGroups || typeof activeGroups !== 'string')
        return {};
    const activeGroupIds = new Set(activeGroups.trim().split(',').filter(Boolean));
    return {
        consentCategories: api
            .GetDomainData()
            .Groups.reduce((acc, { CustomGroupId }) => {
            const groupId = CustomGroupId.trim();
            acc[groupId] = activeGroupIds.has(groupId);
            return acc;
        }, {}),
        dontSend: !userCanBeTracked(),
    };
};
/**
 * Handles subsequent changes to consent configuration.
 */
const handleConsentUpdates = (updateCdpConsent) => {
    getApi().OnConsentChanged(() => {
        updateCdpConsent(getCurrentConsent());
    });
};
export const onetrustConsentAdapter = () => {
    return {
        getCurrentConsent,
        handleConsentUpdates,
        userCanBeTracked,
    };
};
